import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import CartReducer from "./CartSlice";
import WishlistSlice from "./WishlistSlice";
import walletReducer from "./Wallet";
import AuthSlice from "./Auth";
import creditSlice from "./B2b";
import orderReducer from "./Order_history";
import addressReducer from "./AddressSlice";
import pointReducer from "./Point";
import globalProductsReducer from "./globalProductsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "cart",
    "wishlist",
    "auth",
    "wallet",
    "credit",
    "orders",
    "address",
    "point",
  ],
};

const rootReducer = combineReducers({
  cart: CartReducer,
  wishlist: WishlistSlice,
  auth: AuthSlice,
  wallet: walletReducer,
  credit: creditSlice,
  orders: orderReducer,
  address: addressReducer,
  point: pointReducer,
  globalProducts: globalProductsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // ✅ let Redux Toolkit handle middleware automatically
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // optional, helps with redux-persist
    }),
});

export const persistor = persistStore(store);
export default store;
